/* eslint-disable no-undef */
const eventBus = window.theme.searchAutocomplete.eventBus

class SearchAutoCompleteAPILayer {
  constructor () {
    eventBus.subscribe('searchAutoComplete:state:term:updated', () => {
      this.fetchResults()
    })

    eventBus.subscribe(
      'searchAutoComplete:tracking:product:clicked',
      (productData) => {
        if (!this.tracker || !this.currentTerm || !productData?.productId) {
          return
        }

        this.tracker.trackAutocompleteSelect(
          productData.itemName || productData.productId,
          {
            originalQuery: this.currentTerm,
            itemId: productData.productId,
            section: 'Products',
            tr: 'click',
          },
        )
      },
    )
  }

  get client () {
    return window.theme?.constructorIo?.client || null
  }

  get tracker () {
    return this.client?.tracker || null
  }

  get currentTerm () {
    return window.theme.searchAutocomplete.stateLayer?.state?.term || ''
  }

  get emptyResponse () {
    return {
      keywords: {
        hits: [],
      },
      products: {
        hits: [],
      },
    }
  }

  publishResults (response = this.emptyResponse) {
    window.theme.searchAutocomplete.eventBus.publish(
      'searchAutoComplete:api:results:fetched',
      response,
    )
  }

  mapKeywordHit (item) {
    if (!item?.value) return null

    return {
      groupId: '',
      itemId:
        item?.data?.id ||
        item?.data?.item_id ||
        item?.item_id ||
        item?.id ||
        '',
      keyword: item.value,
      resultId: item.result_id || null,
    }
  }

  mapProductHit (item) {
    const productUrl = item?.data?.url || item?.url || ''
    const itemName = item?.data?.name || item?.value || ''

    if (!productUrl) return null

    return {
      groupId: '',
      itemName,
      productId: item?.data?.id || item?.value || '',
      url: productUrl,
      result_id: item?.result_id || null,
      rawData: item,
    }
  }

  mapConstructorResponse (response = {}) {
    const sections = response.sections || {}
    const productHits = Array.isArray(sections.Products)
      ? sections.Products.map((item) => this.mapProductHit(item)).filter(
        Boolean,
      )
      : []
    const keywordHits = Array.isArray(sections['Search Suggestions'])
      ? sections['Search Suggestions']
        .map((item) => this.mapKeywordHit(item))
        .filter(Boolean)
      : []

    return {
      keywords: {
        hits: keywordHits,
      },
      products: {
        hits: productHits,
      },
    }
  }

  async fetchResults () {
    const term = window.theme.searchAutocomplete.stateLayer?.state?.term || ''

    if (!term || !this.client) {
      this.publishResults()
      return
    }

    try {
      const response = await this.client.autocomplete.getAutocompleteResults(
        term,
        {
          resultsPerSection: {
            Products: window.theme.categoryConfig.autoCompleteLimit,
            'Search Suggestions':
              window.theme.categoryConfig.autoCompleteKeywordLimit,
          },
        },
      )

      this.publishResults(this.mapConstructorResponse(response))
    } catch (error) {
      console.error('Failed to fetch Constructor autocomplete results', error)
      this.publishResults()
    }
  }
}
window.theme.searchAutocomplete = window.theme.searchAutocomplete || {}

window.theme.searchAutocomplete.apiLayer = new SearchAutoCompleteAPILayer()
